import locale from "./locale";

const validate = (value, required, regEx) => {
    if (required !== undefined) {
      if (required === true && (value === "" || value === null || value === undefined)) {
        return ({ error: true, errorMessage: locale("required_field") });
      }
    }
    if (regEx !== undefined) {
      if (value !== "" || value !== null) {
        if (!regEx.test(value)) {
          return ({ error: true, errorMessage: locale("invalid_input") });
        }
      }
    }
    return ({ error: false, errorMessage: "" });
  }
  export default validate


// WEBPACK FOOTER //
// ./src/utils/validate.js